function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import localeKeys from '../../../../locales/keys';
import { resetGroupedEntitlementsModalStore, retrieveEntitlementBalances, setGroupedEntitlementsSelectedTab } from '../../../../reducers/actions/grouped.entitlements.modal.actions';
import { GroupedEntitlementsSelectedTabSelector, GroupEntitlementsWithFormattedServiceAttributeSelector, IsLoadingGroupedEntitlementsSelector } from '../../../../reducers/selectors/grouped.entitlements.modal.selectors';
import { ENTITLEMENT_SHARE_STATUS, UNIT_OF_MEASURES } from '../../../../customercare.constants';
import { GROUPED_ENTITLEMENTS_MODAL_TABS } from '../../../../reducers/grouped.entitlements.modal.reducer';
import { updateEntitlementShareStatus } from '../../../../reducers/actions/shared.entitlements.actions';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
var GroupedEntitlementsModalController = /*#__PURE__*/function () {
  function GroupedEntitlementsModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, GroupedEntitlementsModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      ENTITLEMENT_SHARE_STATUS: ENTITLEMENT_SHARE_STATUS,
      GROUPED_ENTITLEMENTS_MODAL_TABS: GROUPED_ENTITLEMENTS_MODAL_TABS,
      localeKeys: localeKeys,
      onSharedActionClicked: this.onSharedActionClicked.bind(this),
      onTabSelected: this.onTabSelected.bind(this),
      selectedTab: null,
      tabs: [{
        id: GROUPED_ENTITLEMENTS_MODAL_TABS.AVAILABLE_FOR_PAYMENT,
        name: i18n.translate(localeKeys.AVAILABLE_FOR_PAYMENT),
        active: true
      }, {
        id: GROUPED_ENTITLEMENTS_MODAL_TABS.AVAILABLE_FOR_USAGE,
        name: i18n.translate(localeKeys.AVAILABLE_FOR_USAGE),
        active: false
      }],
      uiNotificationService: uiNotificationService,
      UNIT_OF_MEASURES: UNIT_OF_MEASURES
    });
  }
  return _createClass(GroupedEntitlementsModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.selectedTab = this.tabs[0];
      var controllerActions = {
        resetGroupedEntitlementsModalStore: resetGroupedEntitlementsModalStore,
        retrieveEntitlementBalances: retrieveEntitlementBalances,
        setGroupedEntitlementsSelectedTab: setGroupedEntitlementsSelectedTab,
        updateEntitlementShareStatus: updateEntitlementShareStatus
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          isLoading: IsLoadingGroupedEntitlementsSelector(store),
          entitlements: GroupEntitlementsWithFormattedServiceAttributeSelector(store),
          selectedTab: GroupedEntitlementsSelectedTabSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.retrieveEntitlementBalances();
    }
  }, {
    key: "retrieveEntitlementBalances",
    value: function retrieveEntitlementBalances() {
      var _this2 = this;
      this.actions.retrieveEntitlementBalances(this.entitlementGroup.EntitlementIdentifier.GroupCode, this.serviceIdentifier).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onTabSelected",
    value: function onTabSelected(selectedTab) {
      this.actions.setGroupedEntitlementsSelectedTab(selectedTab.id);
      this.tabs = this.tabs.map(function (tab) {
        tab.active = selectedTab === tab;
        return tab;
      });
    }
  }, {
    key: "onSharedActionClicked",
    value: function onSharedActionClicked(entitlement) {
      var _this3 = this;
      var newStatus = entitlement.SharingStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? ENTITLEMENT_SHARE_STATUS.DISABLED : ENTITLEMENT_SHARE_STATUS.ENABLED;
      this.actions.updateEntitlementShareStatus(this.state.currentCustomerId, entitlement.EntitlementIdentifier, newStatus).then(function () {
        _this3.uiNotificationService.transientSuccess(i18n.translate(newStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? localeKeys.SHARING_ACTIONS.ENABLE_SUCCESS : localeKeys.SHARING_ACTIONS.DISABLE_SUCCESS));
        _this3.retrieveEntitlementBalances();
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.resetGroupedEntitlementsModalStore();
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    onClose: '&',
    entitlementGroup: '<',
    currencyCode: '<',
    serviceIdentifier: '<?',
    showTotalUsed: '<?'
  },
  controller: GroupedEntitlementsModalController,
  template: require('./grouped.entitlements.modal.template.html')
};